import src from "IMAGE";
export default { src, width: 340, height: 180, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAKUlEQVR42n2KuQkAAAjE7gTdf2QtfEDEQJoQYGBaSKh4BubUkcvGrlg4B4UAHN1YzJ0AAAAASUVORK5CYII="};
